import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { PERMISSION_GRANTED } from 'constants/notifications';
import { REQUEST_PUSH_PERMISSIONS } from 'constants/triggers';
import { reenableWebNotifications } from 'creators/notification-settings';
import { completeTriggerCreator } from 'creators/triggers';
import { registerNewPushSubscription } from 'utilities/notifications';

import { useCheckIfSdkSharedUser } from 'hooks/workspace';

// There are some scenarios where a users push token was not immediately generated.
// This makes sure that if we are given permission to send notifications, we make
// sure to generate a push token and store it to the backend
export const useBackfillPushToken = () => {
  const dispatch = useDispatch();

  const hasBrowserPushPermission =
    window.Notification &&
    window.Notification.permission === PERMISSION_GRANTED;

  const hasWebPushSubscription = useSelector(
    state => state.user.current.hasWebPushSubscription
  );

  const isSdkSharedUser = useCheckIfSdkSharedUser();

  useEffect(() => {
    if (
      !hasBrowserPushPermission ||
      hasWebPushSubscription ||
      isSdkSharedUser
    ) {
      return;
    }

    registerNewPushSubscription('backFillOnLoad');
    dispatch(reenableWebNotifications());
    dispatch(completeTriggerCreator(REQUEST_PUSH_PERMISSIONS));
  }, [
    dispatch,
    hasBrowserPushPermission,
    hasWebPushSubscription,
    isSdkSharedUser,
  ]);
};
